/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Open_Screen_Plan_Day_EditorInputs */

const en_us2_chat_open_screen_plan_day_editor = /** @type {(inputs: Chat_Open_Screen_Plan_Day_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review this plan`)
};

const pt_br2_chat_open_screen_plan_day_editor = /** @type {(inputs: Chat_Open_Screen_Plan_Day_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar este plano`)
};

const es_419_chat_open_screen_plan_day_editor = /** @type {(inputs: Chat_Open_Screen_Plan_Day_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar este plan`)
};

const pt_pt2_chat_open_screen_plan_day_editor = /** @type {(inputs: Chat_Open_Screen_Plan_Day_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rever este plano`)
};

const fr_fr2_chat_open_screen_plan_day_editor = /** @type {(inputs: Chat_Open_Screen_Plan_Day_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Examiner ce programme`)
};

const de_de2_chat_open_screen_plan_day_editor = /** @type {(inputs: Chat_Open_Screen_Plan_Day_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Plan prüfen`)
};

const it_it2_chat_open_screen_plan_day_editor = /** @type {(inputs: Chat_Open_Screen_Plan_Day_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi questa scheda`)
};

/**
* | output |
* | --- |
* | "Review this plan" |
*
* @param {Chat_Open_Screen_Plan_Day_EditorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const chat_open_screen_plan_day_editor = /** @type {((inputs?: Chat_Open_Screen_Plan_Day_EditorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Open_Screen_Plan_Day_EditorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_chat_open_screen_plan_day_editor(inputs)
	if (locale === "es-419") return es_419_chat_open_screen_plan_day_editor(inputs)
	if (locale === "pt-PT") return pt_pt2_chat_open_screen_plan_day_editor(inputs)
	if (locale === "fr-FR") return fr_fr2_chat_open_screen_plan_day_editor(inputs)
	if (locale === "de-DE") return de_de2_chat_open_screen_plan_day_editor(inputs)
	if (locale === "it-IT") return it_it2_chat_open_screen_plan_day_editor(inputs)
	return en_us2_chat_open_screen_plan_day_editor(inputs)
});
export { chat_open_screen_plan_day_editor as "chat.open_screen.plan_day_editor" }